import axios from "../axiosPlugin.js";

export const createRule = (data, loading = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/create",
    method: 'post',
    data: {
      data,
      loading
    },
  })
};

export const getRuleDetail = (data, loading = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/detail/" + data.id,
    method: 'get',
    data: {
      data: {},
      loading
    },
  })
}

export const updateRule = (data, loading = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/update",
    method: 'put',
    data: {
      data,
      loading
    },
  })
}

export const deleteRule = (data, loading = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/delete/" + data.id,
    method: 'delete',
    data: {
      data: {},
      loading
    },
  })
}
